import axiosInstance from "../utils/axiosInstance";

const changeRequestStatus = url =>
  axiosInstance.patch(url).then(response => response);

export default changeRequestStatus;
